import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { KnzComponentProps } from '../../types';

/**
 * 箇条書き / 番号付きリスト（WorkflowList ベース）。
 * params: variant（ordered/unordered）、text（array）
 *
 * マーカー（•/番号）と本文を同じ行高（body2 / lineHeight 1.7）で揃えて、
 * Markdown 描画による縦ズレを防ぐ。
 */
export const List: React.FC<KnzComponentProps> = ({ node, renderInline }) => {
  const variant = (node.params.variant as string) === 'ordered' ? 'ordered' : 'unordered';
  const rawItems = node.params.text;
  const items: string[] = Array.isArray(rawItems) ? rawItems : rawItems ? [String(rawItems)] : [];

  return (
    <Stack spacing={0.75} sx={{ pl: 1 }}>
      {items.map((item, index) => (
        <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start' }}>
          {/* マーカー: 本文と同じ body2 で描画し、行の先頭に揃える */}
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              flexShrink: 0,
              width: variant === 'ordered' ? 22 : 16,
              lineHeight: 1.7,
              userSelect: 'none',
            }}
          >
            {variant === 'ordered' ? `${index + 1}.` : '•'}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            component="div"
            sx={{
              flex: 1,
              minWidth: 0,
              lineHeight: 1.7,
              // Markdown（wmde-markdown）側の margin・行高を打ち消してマーカーと揃える
              '& .wmde-markdown, & .wmde-markdown p, & .wmde-markdown span': {
                margin: 0,
                fontSize: 'inherit',
                lineHeight: 'inherit',
                color: 'inherit',
                background: 'transparent',
              },
            }}
          >
            {renderInline(item)}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
};

export default List;
